{
  "home.cards.empty": "No cards to show right now.",
  "home.cards.errorState": "Failed to load cards.",
  "home.cards.loading": "Loading cards…",
  "home.feedback.close": "Close",
  "home.feedback.error": "Sending your feedback failed. Please try again.",
  "home.feedback.description": "Provide a rating and free-form feedback",
  "home.feedback.edgeMax": "Very satisfied",
  "home.feedback.edgeMin": "Very dissatisfied",
  "home.feedback.label": "Feedback",
  "home.feedback.legend": "Choose a rating 1–5",
  "home.feedback.ratingLabel": "Rating {n}",
  "home.feedback.submit": "Send",
  "home.feedback.submitPending": "Sending…",
  "home.feedback.success": "Thank you for your feedback",
  "home.feedback.textareaLabel": "Free-form feedback",
  "home.feedback.textareaPlaceholder": "By giving us feedback, you help us improve our services",
  "home.feedback.title": "Give feedback",
  "home.greeting.anonymous": "Welcome",
  "home.greeting.day": "Good day,",
  "home.greeting.evening": "Good evening,",
  "home.greeting.morning": "Good morning,",
  "home.overdueFee.title": "Your membership fee is overdue",
  "home.overdueFee.body": "Your membership fee is still unpaid although the due date has passed. If you have already paid, it can take a few banking days for the payment to be registered.",
  "home.overdueFee.action": "Go to membership fee",
  "home.quickAccess.contact.subtitle": "Employment or salary questions? Membership enquiries?",
  "home.quickAccess.contact.title": "Contact us",
  "home.quickAccess.deferredBadge": "Coming soon",
  "home.quickAccess.lakiruutu.subtitle": "Lakiruutu videos with legal guidance for work matters",
  "home.quickAccess.lakiruutu.title": "Lakiruutu at your service",
  "home.quickAccess.tools.subtitle": "Helpful tools and calculators at your disposal",
  "home.quickAccess.tools.title": "Tools and calculators",
  "home.tabs.label": "Home sections",
  "home.tabs.lakikaveri": "Lakikaveri",
  "home.tabs.palvelutEdut": "Membership and benefits"
}
